import { MenuItem, SubMenuItem } from '../models/shared/menu.model';

// Small factory kept local (avoids repeating object literal keys)
const createItem = (label: string, route: string): SubMenuItem => ({ label, route });

// ---------------- Shared Sub-Collections (de-duplicated) ----------------
// Maintenance Assets submenu children
const maintenanceAssetsChildren: SubMenuItem[] = [
  createItem('Maintenance.AssetsList', '/maintenance/assets'),
  createItem('Maintenance.AssetModels', '/maintenance/assets/models'),
  createItem('Maintenance.AssetBrand', '/declarations/Brand'),
  createItem('Maintenance.AssetStatus', '/maintenance/assets/status')
];

// Maintenance Service Categories submenu children
const maintenanceServiceCategoryChildren: SubMenuItem[] = [
  createItem('Maintenance.ServiceCategoriesList', '/maintenance/services-category/services-category'),
  createItem('Maintenance.Priorities', '/maintenance/services-category/priorities'),
  createItem('Maintenance.StepsGroups', '/maintenance/services-category/work-fllow-steps-group'),
  createItem('Maintenance.Steps', '/maintenance/services-category/work-fllow-steps'),
  createItem('Maintenance.WorkflowActions', '/maintenance/services-category/work-fllow-steps-action'),
  createItem('Instructions.InstructionsAndGroups', '/maintenance/services-category/instructions-and-instruction-group')
];

// Personnel affairs children
const personnelAffairsChildren: SubMenuItem[] = [
  createItem('PersonnelAffairs.ConnectedUsers', '/permissions/online-users'),
  createItem('PersonnelAffairs.AppVersions', '/permissions/appVersions'),
  createItem('PersonnelAffairs.DepartmentsSections', '/share/department_section'),
  createItem('PersonnelAffairs.JobTitles', '/hr/jobs'),
  createItem('PersonnelAffairs.EmployeeProfile', '/employee/employeeprofile'),
  createItem('PersonnelAffairs.EmployeeList', '/employee/employeelist'),
  createItem('PersonnelAffairs.UploadEmployeeData', '/employee/uploadWithExcel')
];

// User permissions children
const userPermissionsChildren: SubMenuItem[] = [
  createItem('UserPermissions.Roles', '/permissions/roles'),
  createItem('UserPermissions.Groups', '/permissions/notimodule'),
  createItem('PersonnelAffairs.AttendanceDeparture', '/employee/employeeAttendance'),
  createItem('UserPermissions.Clients', '/permissions/clients'),
  createItem('UserPermissions.EmployeeUser', '/permissions/employee-users'),
  createItem('UserPermissions.VendorUser', '/permissions/vendor-users'),
  createItem('UserPermissions.OnlineUsers', '/permissions/online-users')
];

// Vendors children (shared between full menu and vendor-specific view)
const vendorChildren: SubMenuItem[] = [
  createItem('Vendors.VendorCategoryDefination', '/vendor/classification'),
  createItem('Vendors.VendorActivityDefination', '/vendor/activity'),
  createItem('Vendors.VendorCompanyDefination', '/vendor/maincompany'),
  createItem('Vendors.VendorDefination', '/vendor/vendorlist')
];

// Warehouses children
const warehousesChildren: SubMenuItem[] = [
  createItem('GeneralSettings.CommitteeTypes', '/warehouses/committee-types'),
  createItem('CategoriesAndSubcategories.MenuTitle', '/warehouses/category-and-subcategory'),
  createItem('CommitteeAndMember.MenuTitle', '/warehouses/committees-and-members'),
  createItem('Items.MenuTitle', '/warehouses/items'),
  createItem('Units.Title', '/warehouses/units'),
  createItem('UnitsPlacement.Title', '/warehouses/units-placement'),
  createItem('FinancialYear.Title', '/warehouses/financial-year')
];

// Vehicles children
const vehiclesChildren: SubMenuItem[] = [
  createItem('VehicleModels.Title', '/vehicles/vehicle-models'),
  createItem('Vehicles.VehicleMenu', '/vehicles/vehicles-list'),
  createItem('Vehicles.Title', '/vehicles/car-expenses-types'),
  createItem('VehicleExpenses.Menu', '/vehicles/car-expenses'),
];

//reports children
const reportsChildren: SubMenuItem[] = [
  createItem('Reports.ServiceRequestReport', '/reports/service-request-report'),
  createItem('Reports.SparePartsReport', '/reports/spare-parts-report'),
  createItem('Reports.WorkOrderReport', '/reports/work-order-report'),
  createItem('Reports.AssetsReport', '/reports/asset-report'),
];

// Single vendor work order item reused (avoid string duplication)
const vendorWorkOrderItem: SubMenuItem = createItem('Maintenance.Vendor_WorkOrders', '/maintenance/vendor-workorder-list');

export class Menu {
  public static readonly pages: MenuItem[] = [
    {
      group: 'Basic',
      separator: false,
      items: [
        {
          icon: 'pi pi-wrench',
          label: 'TechnicalSupport.Maintenance',
          route: '/maintenance',
          children: [
            createItem('Maintenance.Dashboard', '/maintenance/dashboard'),
            createItem('Reports.ServiceRequestReport', '/maintenance/client-dashboard'),
            createItem('Maintenance.CallCenter', '/maintenance/callcenter'),
            createItem('Maintenance.Instructions', '/maintenance/pminstruction'),
            { label: 'Maintenance.Assets', route: '/maintenance/assets', children: maintenanceAssetsChildren },
            { label: 'Maintenance.ServiceCategories', route: '/maintenance/services-category', children: maintenanceServiceCategoryChildren },
            createItem('Maintenance.Teams', '/maintenance/team'),
            createItem('Maintenance.title', '/maintenance/pm/viewallpm'),
            createItem('Maintenance.RoutineCheck', '/maintenance/routine-check'),
            createItem('Maintenance.RoutineCheckReport', '/maintenance/routine-check-report'),
            vendorWorkOrderItem

          ],
        },
        {
          icon: 'pi pi-users',
          label: 'PersonnelAffairs.Title',
          route: '/personnel-affairs',
          children: personnelAffairsChildren,
        },
        {
          icon: 'pi pi-shield',
          label: 'UserPermissions.Title',
          route: '/user-permissions',
          children: userPermissionsChildren,
        },
        {
          icon: 'pi pi-truck',
          label: 'Vendors.Title',
          route: '/vendor',
          children: vendorChildren,
        },
        {
          icon: 'pi pi-warehouse',
          label: 'Items.warehouses',
          route: '/warehouses',
          children: warehousesChildren,
        },
        {
          icon: 'pi pi-chart-bar',
          label: 'Reports.Title',
          route: '/reports',
          children: reportsChildren,
        },
        {
          icon: 'pi pi-truck',
          label: 'Vehicles.ModuleTitle',
          route: '/vehicles',
          children: vehiclesChildren,
        }
      ],
    }
  ];

  public static readonly vendorPages: MenuItem[] = [
    { group: 'Basic', separator: false, items: [ { icon: 'pi pi-wrench', label: vendorWorkOrderItem.label, route: vendorWorkOrderItem.route } ] }
  ];
}

